import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
import Header from './components/Header'
import Footer from './components/Footer'

const App = () => {
  // useEffect(() => {
  //   fetch('https://admin.mabubakaransari.com/api/log_visitor.php'); // Update with the correct path
  // }, []);
  
  return (
    <div className=' text-light'>
      <BrowserRouter >
      <div className='grad'>
      <Header/>
      <div className='pt-[5.8rem] ' id='home'>
      <Routes>
        <Route path='/' element={<Home/>}/>
      </Routes>
      </div>
      <Footer/>
      </div>
      </BrowserRouter>
    </div>
  )
}

export default App
